import React from 'react'

import './values.css'

const Values = ((props)=>(
	<div className="row__values">
		<div>
				
			{
				props.values.map((value)=>(
					<div  key={value.id} className="col">
						<div className="row">
							<div className="col">
								<div className="title">
									{value.title}
								</div>
								<div className="subtitle">
									{value.subtitle}
								</div>
							</div>
							{
								value && value.values ? value.values.map((val)=>(
									<div key={val.id} className="col">
										<div className="title">
											{val.title}
										</div>
										<div className="subtitle">
											{val.value}
										</div>
									</div>
								)): ''
							}
						</div>
					</div>
				))
			}
		</div>
	</div>
))


export default Values


// WEBPACK FOOTER //
// ./src/Components/Values/index.js